import { IFechaFestiva } from "../../entities/catalogos/IFechaFestiva";

export const LOAD_DIAS_FESTIVOS_SUCCESS = 'LOAD_DIAS_FESTIVOS_SUCCESS';


interface ILoadDiasFestivos {
    type: typeof LOAD_DIAS_FESTIVOS_SUCCESS
    diasFestivos: IFechaFestiva[]
}

export type DiasFestivosActionTypes = ILoadDiasFestivos
